module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    staticClass: "ui pointing red tiny basic label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ef23a02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errmsg.vue
// module id = 440
// module chunks = 28